/**
 * Derives the signed-in actor's own Agent id from the real
 * GET /api/backoffice/home accessScopes array - never from a route param,
 * never invented. accessScopes here only ever contains scopes the backend
 * has already resolved as active (AccessScopeDto has no accessStatus field
 * because AccessScopeRepository.GetActiveScopesForUserAsync only returns
 * active rows in the first place), so no client-side status check is
 * needed on top of this.
 *
 * Returns null for anyone without an owning Agent scope (SuperAdmin, Super
 * Agent, PLC, or an Agent scoped to a different agentId) - callers must
 * treat null as "show the reserved/forbidden state, never call the invite
 * card API."
 */
export function findOwningAgentId(accessScopes) {
  if (!Array.isArray(accessScopes)) {
    return null;
  }

  const ownScope = accessScopes.find(
    (scope) => scope?.roleCode === "Agent" && scope?.scopeType === "Agent" && Boolean(scope?.scopeId)
  );

  return ownScope?.scopeId ?? null;
}
